import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemHatBell extends Item {
    constructor() {
        super(definitions.ITEM_ID.HAT_BELL, texture("prop_hat_bell_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(0, 0));
    }

    _playIdleAnimation() {
        this._view.animationSpeed = 10;
        this._view.gotoAndPlay("idle", true);
    }
}